let embibeTempQuestion = {
    "success": true, "result": {
        "EM0057051": {
            "code": "EM0057051",
            "version": 14,
            "language": "en",
            "body": "Arrhenius equation is:",
            "answers": [{
                "body": "<math><mo>∆</mo><mi>H</mi><mo>=</mo><mo>∆</mo><mi>E</mi><mo>+</mo><mo>∆</mo><msub><mrow><mi>n</mi></mrow><mrow><mi>g</mi></mrow></msub><mi> </mi><mi>R</mi><mi>T</mi></math>",
                "code": "EM0057051-1",
                "position": 1
            }, {
                "body": "<math><mo>∆</mo><mi>G</mi><mo>=</mo><mo>∆</mo><mi>H</mi><mo>-</mo><mi>T</mi><mo>.</mo><mo>∆</mo><mi>S</mi></math>",
                "code": "EM0057051-2",
                "position": 2
            }, {
                "body": "<math><mi>k</mi><mo>=</mo><mi>A</mi><msup><mrow><mi>e</mi></mrow><mrow><mo>-</mo><msub><mrow><mi>E</mi></mrow><mrow><mi>a</mi></mrow></msub><mo>/</mo><mi>R</mi><mi>T</mi></mrow></msup></math>",
                "code": "EM0057051-3",
                "position": 3
            }, {"body": "None of these", "code": "EM0057051-4", "position": 4}],
            "category": "Single Choice",
            "difficulty_level": 2,
            "ideal_time": 30,
            "unique_code": "embibe--en--EM0057051--14",
            "learning_map": {
                "code": "lm409",
                "level": "chapter",
                "namespace": "embibe",
                "goal_code": "gl8",
                "exam_code": "ex4",
                "subject_code": "su13",
                "unit_code": "un49",
                "chapter_code": "ch216",
                "goal_name": "Engineering",
                "exam_name": "JEE Main",
                "subject_name": "Chemistry",
                "unit_name": "Physical Chemistry",
                "chapter_name": "Chemical Kinetics",
                "goal_slug": "engineering"
            },
            "hints": [{"id": "hint-1", "body": "Direct formula"}],
            "tags": [],
            "difficulty_band": "easy",
            "namespace": "embibe"
        }
    }, "errors": {}
};
let embibeTempExplaination = {
    "result": {
        "EM0057051": {
            "code": "EM0057051",
            "version": 14.0,
            "language": "en",
            "body": "Arrhenius equation is:",
            "answers": [{
                "body": "<math><mo>∆</mo><mi>H</mi><mo>=</mo><mo>∆</mo><mi>E</mi><mo>+</mo><mo>∆</mo><msub><mrow><mi>n</mi></mrow><mrow><mi>g</mi></mrow></msub><mi> </mi><mi>R</mi><mi>T</mi></math>",
                "code": "EM0057051-1",
                "position": 1.0,
                "is_correct": false
            }, {
                "body": "<math><mo>∆</mo><mi>G</mi><mo>=</mo><mo>∆</mo><mi>H</mi><mo>-</mo><mi>T</mi><mo>.</mo><mo>∆</mo><mi>S</mi></math>",
                "code": "EM0057051-2",
                "position": 2.0,
                "is_correct": false
            }, {
                "body": "<math><mi>k</mi><mo>=</mo><mi>A</mi><msup><mrow><mi>e</mi></mrow><mrow><mo>-</mo><msub><mrow><mi>E</mi></mrow><mrow><mi>a</mi></mrow></msub><mo>/</mo><mi>R</mi><mi>T</mi></mrow></msup></math>",
                "code": "EM0057051-3",
                "position": 3.0,
                "is_correct": true
            }, {"body": "None of these", "code": "EM0057051-4", "position": 4.0, "is_correct": false}],
            "category": "Single Choice",
            "difficulty_level": 2.0,
            "ideal_time": 30.0,
            "unique_code": "embibe--en--EM0057051--14",
            "learning_map": {
                "code": "lm409",
                "level": "chapter",
                "namespace": "embibe",
                "goal_code": "gl8",
                "exam_code": "ex4",
                "subject_code": "su13",
                "unit_code": "un49",
                "chapter_code": "ch216",
                "goal_name": "Engineering",
                "exam_name": "JEE Main",
                "subject_name": "Chemistry",
                "unit_name": "Physical Chemistry",
                "chapter_name": "Chemical Kinetics",
                "goal_slug": "engineering"
            },
            "hints": [{"id": "hint-1", "body": "Direct formula"}],
            "tags": [],
            "difficulty_band": "easy",
            "correct_answer_csv": "EM0057051-3",
            "answer_explanation": {
                "answers": [{
                    "correct": false,
                    "body": {"en": "<math><mo>∆</mo><mi>H</mi><mo>=</mo><mo>∆</mo><mi>E</mi><mo>+</mo><mo>∆</mo><msub><mrow><mi>n</mi></mrow><mrow><mi>g</mi></mrow></msub><mi> </mi><mi>R</mi><mi>T</mi></math>"},
                    "explanation": {},
                    "position": 1.0,
                    "code": "EM0057051-1"
                }, {
                    "correct": false,
                    "body": {"en": "<math><mo>∆</mo><mi>G</mi><mo>=</mo><mo>∆</mo><mi>H</mi><mo>-</mo><mi>T</mi><mo>.</mo><mo>∆</mo><mi>S</mi></math>"},
                    "explanation": {},
                    "position": 2.0,
                    "code": "EM0057051-2"
                }, {
                    "correct": true,
                    "body": {"en": "<math><mi>k</mi><mo>=</mo><mi>A</mi><msup><mrow><mi>e</mi></mrow><mrow><mo>-</mo><msub><mrow><mi>E</mi></mrow><mrow><mi>a</mi></mrow></msub><mo>/</mo><mi>R</mi><mi>T</mi></mrow></msup></math>"},
                    "explanation": {"en": "Arrhenius equation gives relation between rate constant and temperature of a reaction. It can be written in many forms, as<br />\n<br />\n<math><mi>k</mi><mo>=</mo><mi>A</mi><msup><mrow><mi>e</mi></mrow><mrow><mo>-</mo><msub><mrow><mi>E</mi></mrow><mrow><mi>a</mi></mrow></msub><mo>/</mo><mi>R</mi><mi>T</mi></mrow></msup></math><br />\n<br />\nWhere, k = rate constant<br />\n<br />\nE<sub>a </sub>= activation energy<br />\n<br />\nT = absorbption temperature<br />\n<br />\nA = frequency factor"},
                    "position": 3.0,
                    "code": "EM0057051-3"
                }, {
                    "correct": false,
                    "body": {"en": "None of these"},
                    "explanation": {},
                    "position": 4.0,
                    "code": "EM0057051-4"
                }], "concepts_data": [{
                    "id": 6902.0,
                    "code": "KTCK02",
                    "type": "concept",
                    "name": "Arrhenius Equation and Effect of Temperature on Reaction Rate",
                    "description": "Arrhenius proposed a quantitative relationship between rate constant and temperature as,<br />\r\n<br />\r\n<math> <mrow> <mtext>k</mtext> <mo>=</mo> <msup> <mtext>Ae</mtext> <mrow> <mo>-</mo> <msub> <mtext>E</mtext> <mtext>a</mtext> </msub> <mo>/</mo> <mtext>RT</mtext> </mrow> </msup> </mrow> </math>&nbsp;&nbsp; .... (i)<br />\r\n<br />\r\nThe equation is called Arrhenius equation.<br />\r\n<br />\r\nIn which constant A is known as frequency factor. This factor is related to number of binary molecular collision per second per litre.<br />\r\n<br />\r\nE<sub>a</sub> is the activation energy.<br />\r\n<br />\r\nT is the absolute temperature and R is the gas constant.<br />\r\n<br />\r\nBoth A and E<sub>a</sub> are collectively known as <strong>Arrhenius parameters.</strong><br />\r\n<br />\r\nTaking logarithm equation (i) may be written as,<br />\r\n<br />\r\n<math> <mrow> <mtext>log k</mtext> <mo>=</mo> <mtext>log A</mtext> <mo>-</mo> <mfrac> <mrow> <msub> <mtext>E</mtext> <mtext>a</mtext> </msub> </mrow> <mrow> <mtext>2.303 RT</mtext> </mrow> </mfrac> </mrow> </math>&nbsp;&nbsp; .... (ii)<br />\r\n<br />\r\nRate constants for the reaction at two different temperatures T<sub>1</sub> and T<sub>2</sub><br />\r\n<br />\r\n<math> <mrow> <mtext>log</mtext> <mfrac> <mrow> <msub> <mtext>k</mtext> <mn>2</mn> </msub> </mrow> <mrow> <msub> <mtext>k</mtext> <mn>1</mn> </msub> </mrow> </mfrac> <mo>=</mo> <mfrac> <mrow> <msub> <mtext>E</mtext> <mtext>a</mtext> </msub> </mrow> <mrow> <mtext>2.303R</mtext> </mrow> </mfrac> <mfenced close=\"]\" open=\"[\" separators=\",\"> <mrow> <mfrac> <mrow> <mn>1</mn> </mrow> <mrow> <msub> <mtext>T</mtext> <mn>1</mn> </msub> </mrow> </mfrac> <mo>-</mo> <mfrac> <mrow> <mn>1</mn> </mrow> <mrow> <msub> <mtext>T</mtext> <mn>2</mn> </msub> </mrow> </mfrac> </mrow> </mfenced> </mrow> </math>&nbsp;&nbsp; .... (iii)<br />\r\n<br />\r\nWhere k<sub>1</sub> and k<sub>2</sub> are rate constant at temperatures T<sub>1</sub> and T<sub>2</sub> respectively (T<sub>2</sub> &gt; T<sub>1</sub>).",
                    "is_important": "true",
                    "url": "/study/arrhenius-equation-and-effect-of-temperature-on-reaction-rate-concept?entity_code=KTCK02"
                }], "video_url": null
            },
            "namespace": "embibe"
        }
    },
    "attempt": {
        "attemptId": "5d5bf03a553ef8000187da34",
        "correct_answer": "3",
        "correct_answer_csv": "EM0057051-3",
        "selected_answer_csv": "EM0057051-4",
        "timeSpent": 250.0,
        "totalEmbiums": 175
    },
    "success": true,
    "errors": {}
}

export {embibeTempQuestion, embibeTempExplaination}